export enum ChatFrom {
  CHAT_ICON_NAVBAR = 'faqHome',
  CHAT_ATTENTION_CHANNEL = 'faqChannelCard',
  CHAT_FAQ_QUESTION = 'faqQuestion',
}
